import logger from '@/modules/Logger';
import { VIDEO_LOW_STREAM_CONFIG } from '@/modules/webrtc/agora/const';
import { buildJoinMeta, joinPrefix } from '@/modules/webrtc/joinLogUtils';

export default {
  // Enable dual-stream mode to enable switching between high and low stream quality
  async enableDualStream() {
    try {
      // video profile of the low-quality stream
      this.rtc.setLowStreamParameter(VIDEO_LOW_STREAM_CONFIG);

      await this.rtc.enableDualStream();

      logger.info(`${joinPrefix('Agora')} Dual stream mode enabled successfully`, buildJoinMeta({ provider: 'agora', lessonId: this.lessonId }));
    } catch (error) {
      logger.debug('[Agora] Error while enabling dual stream', {
        operation: 'enable:dual-stream',
        error: error.message
      });

      logger.warn(`${joinPrefix('Agora')} Failed to enable dual stream mode: ${error.message}`, buildJoinMeta({ provider: 'agora', lessonId: this.lessonId }));
    }
  }
};
